import * as types from "../constants/ActionTypes";

const tabulatedInfos = (state = {}, action) => {
  switch (action.type) {
    case types.EDIT_TABULATED_INFOS:
      return { ...state, [`${action.cdr}`]: action.tabulatedInfos };
    case types.ATD_DEL:
      const hasTabulationOfThisAtd = Boolean(state[`${action.idatendimento}`]);
      if (!hasTabulationOfThisAtd) {
        return state;
      }
      const newState = { ...state };
      delete newState[`${action.idatendimento}`];
      return newState;
    case types.REMOVE_CLASSIFICATION_FROM_TABULATED_INFO:
      if (!Array.isArray(state[`${action.cdr}`])) return state;
      const newStateToRemoveItem = { ...state };
      newStateToRemoveItem[`${action.cdr}`] = newStateToRemoveItem[
        `${action.cdr}`
      ].filter(
        (tabulatedInfo) =>
          parseInt(tabulatedInfo.id) !== parseInt(action.idPath),
      );
      return newStateToRemoveItem;
    default:
      return state;
  }
};

export default tabulatedInfos;
